const TranslationPermissions = {
  edit: 'translation:edit',
  create: 'translation:create',
  delete: 'translation:delete',
  view: 'translation:view',
}

export default TranslationPermissions
